export default "__VITE_ASSET__BklksRND__"